module.exports = __webpack_public_path__ + "img/residence.ce7060e6.svg";